import gql from "graphql-tag";

export const JOURNAL_ENTRIES = gql`
    query journalEntries2(
        $accountingRunId: GraphQLObjectId
        $clientId: GraphQLObjectId
        $accountingPeriod: String
        $batch: AccountingBatchType
    ) {
        journalEntries2(accountingRunId: $accountingRunId, clientId: $clientId, accountingPeriod: $accountingPeriod, batch: $batch) {
            _id
            clientId
            accountingRunId
            accountingPeriod
            batch
            description
            effectiveDate
            number
            externalNumber
            portfolioTransactionId
            transactions {
                amount
                quantity
                localAmount
                accountingAmount
                instrumentId
                instrument {
                    _id
                    name
                    currency
                }
                tAccountNumber
                type
                valueDate
            }
        }
    }
`;

export const JOURNAL_ENTRY = gql`
    query journalEntry2($_id: GraphQLObjectId, $portfolioTransactionId: GraphQLObjectId) {
        journalEntry2(_id: $_id, portfolioTransactionId: $portfolioTransactionId) {
            _id
            clientId
            accountingRunId
            accountingPeriod
            batch
            description
            effectiveDate
            number
            externalNumber
            portfolioTransactionId
            portfolioTransaction {
                _id
                items {
                    _id
                }
            }
            transactions {
                amount
                quantity
                localAmount
                accountingAmount
                instrumentId
                instrument {
                    _id
                    name
                }
                tAccountNumber
                type
                valueDate
            }
        }
    }
`;

export const LATEST_EXTERNAL_NUMBER = gql`
    query latestExternalNumber2($clientId: GraphQLObjectId!, $accountingPeriod: String!) {
        latestExternalNumber2(clientId: $clientId, accountingPeriod: $accountingPeriod)
    }
`;

export const CREATE_JOURNAL_ENTRY = gql`
    mutation createJournalEntry2($input: CreateJournalEntry2Input!) {
        createJournalEntry2(input: $input) {
            _id
            clientId
            accountingRunId
            accountingPeriod
            batch
            description
            effectiveDate
            number
            externalNumber
            transactions {
                amount
                quantity
                localAmount
                accountingAmount
                instrumentId
                tAccountNumber
                type
                valueDate
            }
        }
    }
`;

export const UPDATE_JOURNAL_ENTRY = gql`
    mutation updateJournalEntry2($input: UpdateJournalEntry2Input!) {
        updateJournalEntry2(input: $input) {
            _id
            clientId
            accountingRunId
            accountingPeriod
            batch
            description
            effectiveDate
            number
            externalNumber
            transactions {
                amount
                quantity
                localAmount
                accountingAmount
                instrumentId
                tAccountNumber
                type
                valueDate
            }
        }
    }
`;

export const UPDATE_EXTERNAL_NUMBERS = gql`
    mutation updateExternalNumbers2($input: [UpdateExternalNumberInput!]!) {
        updateExternalNumbers2(input: $input) {
            _id
            externalNumber
        }
    }
`;

export const DELETE_JOURNAL_ENTRY = gql`
    mutation deleteJournalEntry2($_id: GraphQLObjectId!) {
        deleteJournalEntry2(_id: $_id)
    }
`;
